import Highcharts from "highcharts"
import "highcharts/modules/exporting"
import "highcharts/modules/export-data"
import "highcharts/modules/accessibility"
import "highcharts/modules/no-data-to-display"
import "highcharts/modules/pattern-fill"

Highcharts.setOptions({
    exporting: {
        enabled: false, // Hides the button, but API methods are still available. We implement our own export menu.
    },
    palette: {
        colorScheme: "light", // Highcharts 13 defaults to "light dark", which follows the browser's dark mode. The platform doesn't support dark mode.
    },
})
